import { Artefact, ArtefactDetectionConfig, ArtefactDetectionResult } from "@/types/artefacts";

/**
 * Base interface for all artefact detectors
 */
export interface IArtefactDetector {
  detect(
    content: string,
    messageId: string,
    config: ArtefactDetectionConfig,
  ): ArtefactDetectionResult;
}

/**
 * Base class providing common functionality for all detectors
 */
export abstract class BaseArtefactDetector implements IArtefactDetector {
  abstract detect(
    content: string,
    messageId: string,
    config: ArtefactDetectionConfig,
  ): ArtefactDetectionResult;

  /**
   * Generate a unique artefact ID
   */
  protected generateId(messageId: string, type: string, index: number): string {
    return `${messageId}-${type}-${index}`;
  }

  /**
   * Get current timestamp in ISO format
   */
  protected getCurrentTimestamp(): string {
    return new Date().toISOString();
  }

  /**
   * Create basic artefact metadata
   */
  protected createMetadata(
    detectionPattern: string,
    estimatedSize: string,
    additionalProps: Record<string, any> = {},
  ) {
    return {
      detectionPattern,
      estimatedSize,
      ...additionalProps,
    };
  }

  /**
   * Validate content before processing
   */
  protected validateContent(content: string): boolean {
    return Boolean(content && typeof content === "string" && content.trim().length > 0);
  }

  /**
   * Create detection result
   */
  protected createResult(
    artefacts: Artefact[],
    skippedCount: number = 0,
    warnings: string[] = [],
  ): ArtefactDetectionResult {
    return {
      artefacts,
      skippedCount,
      warnings,
    };
  }
}
